import {API} from "aws-amplify";
import {awsApiName} from "../../shared/amplify/amplify-utils";
import {Project} from "../../entity/model/project";
import {RequestBody} from "../../entity/core/request-body";
import {ProjectStats} from "../../entity/resource/project-stats";
import {ProjectResource} from "../../entity/resource/project-resource";

export default class ProjectAgent {

    getProjects = async (organizationId: string, isAdmin: boolean): Promise<ProjectResource | Project[]> => {
        return API.get(awsApiName, `/organizations/${organizationId}/projects${!isAdmin ? '/assigned-to-user' : ''}`, {});
    }

    getProjectStats = async (organizationId: string): Promise<ProjectStats> => {
        return API.get(awsApiName, `/organizations/${organizationId}/projects/stats`, {});
    }

    createProject = async (organizationId: string, requestBody: RequestBody): Promise<Project> => {
        return API.post(awsApiName, `/organizations/${organizationId}/projects`, requestBody);
    }

    updateProject = async (organizationId: string, projectId: string, requestBody: RequestBody): Promise<Project> => {
        return API.patch(awsApiName, `/organizations/${organizationId}/projects/${projectId}`, requestBody);
    }

    assignProject = async (organizationId: string, projectId: string, requestBody: RequestBody): Promise<Project> => {
        return API.post(awsApiName, `/organizations/${organizationId}/projects/${projectId}/assign-users`, requestBody);
    }

    moveProjectToOnHold = async (organizationId: string, projectId: string): Promise<Project> => {
        return API.post(awsApiName, `/organizations/${organizationId}/projects/${projectId}/move-to-onhold`, {});
    }

    moveProjectFromOnHold = async (organizationId: string, projectId: string): Promise<Project> => {
        return API.post(awsApiName, `/organizations/${organizationId}/projects/${projectId}/move-from-onhold`, {});
    }

    deleteProject = async (organizationId: string, projectId: string): Promise<void> => {
        await API.del(awsApiName, `/organizations/${organizationId}/projects/${projectId}`, {});
    }

    getProjectById = async (organizationId: string, projectId: string): Promise<Project> => {
        return API.get(awsApiName, `/organizations/${organizationId}/projects/${projectId}`, {});
    }
}
